export enum ControllerEventEnum {
  OnPlay = 'onPlay',
  OnPause = 'onPause',
  OnForward = 'onForward',
  OnBackward = 'onBackward'
}

export enum ControllerTypeEnum {
  Start = 'start',
  Pause = 'pause',
  Forward = 'forward',
  Backward = 'backward'
}
